import { Button } from "design-system/atoms/Button"
import { NotebookPen } from "lucide-react"
import { useUpsertNoteMutation } from "modules/notes/hooks/useUpsertNoteMutation"
import { useTranslation } from "react-i18next"

interface CreateNoteButtonProps {
  conversationId: string
  inputs: Record<string, string>
  onSetInputs: (callback: (prev: Record<string, string>) => Record<string, string>) => void
  onExitNoteMode: () => void
}

export function CreateNoteButton({
  conversationId,
  inputs,
  onSetInputs,
  onExitNoteMode,
}: CreateNoteButtonProps) {
  const { t } = useTranslation()
  const { mutateAsync: upsertNote, isPending } = useUpsertNoteMutation()

  const text = inputs[conversationId] || ""
  const isEmpty = text.length === 0

  async function onClick() {
    if (isEmpty) return
    await upsertNote({ conversationId, text })
    onSetInputs((prev) => ({ ...prev, [conversationId]: "" }))
    onExitNoteMode()
  }

  return (
    <Button
      type="button"
      size="default"
      variant="outline"
      disabled={isEmpty || isPending}
      onClick={onClick}
    >
      <NotebookPen size={16} />
      <span>{t("conversations.chat.notes.createNote")}</span>
    </Button>
  )
}
